export const SUPER_ADMIN = 'SUPER_ADMIN';
export const ADMIN_COMMUNITY = 'ADMIN_COMMUNITY';
export const ADMIN_BASIC = 'ADMIN_BASIC';
export const ADMIN = 'ADMIN';
export const ANALYTICS = 'ANALYTICS';
export const DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = 'DEVELOPER_BRANCH_LEADER_SUPERVISOR_II';
export const DEVELOPER_BRANCH_LEADER_SUPERVISOR = 'DEVELOPER_BRANCH_LEADER_SUPERVISOR';
export const DEVELOPER_BRANCH_LEADER = 'DEVELOPER_BRANCH_LEADER';
export const DEVELOPER_SITEPLAN = 'DEVELOPER_SITEPLAN';
export const DEVELOPER_AGENT_LEADER = 'DEVELOPER_AGENT_LEADER';
export const DEVELOPER_AGENCY_ADMIN = 'DEVELOPER_AGENCY_ADMIN';
export const DEVELOPER_EXECUTIVE = 'DEVELOPER_EXECUTIVE';
export const DEVELOPER_HEADQUARTERS = 'DEVELOPER_HEADQUARTERS';
export const DEVELOPER_TEAM_LEADER = 'DEVELOPER_TEAM_LEADER';
export const CREDIT_CONTROL = 'CREDIT_CONTROL';
export const CREDIT_ADMIN = 'CREDIT_ADMIN';
export const FINANCE_EXECUTIVE = 'FINANCE_EXECUTIVE';
export const CREDIT_CONTROL_SALES_STAFF = 'CREDIT_CONTROL_SALES_STAFF';
export const CREDIT_CONTROL_SALES_ADMIN = 'CREDIT_CONTROL_SALES_ADMIN';
export const COMMISSION_TRACKER_HEADQUARTERS = 'COMMISSION_TRACKER_HEADQUARTERS';
export const COMMISSION_TRACKER_SUPERVISOR = 'COMMISSION_TRACKER_SUPERVISOR';
export const COMMISSION_TRACKER_SALES_MANAGER = 'COMMISSION_TRACKER_SALES_MANAGER';
export const COMMISSION_TRACKER_SALES_ADMIN = 'COMMISSION_TRACKER_SALES_ADMIN';
export const COMMISSION_TRACKER_STAFF = 'COMMISSION_TRACKER_STAFF';
export const COMMISSION_TRACKER_TEAM_LEADER = 'COMMISSION_TRACKER_TEAM_LEADER';
export const COMMISSION_TRACKER_AGENCY_ADMIN = 'COMMISSION_TRACKER_AGENCY_ADMIN';
export const COMMISSION_TRACKER_AGENT = 'COMMISSION_TRACKER_AGENT';

// group ids
export const GROUP_ID_SUPER_ADMIN = '1';
export const GROUP_ID_ADMIN_COMMUNITY = '15';
export const GROUP_ID_ADMIN_BASIC = '14';
export const GROUP_ID_ADMIN = '2';

export const GROUP_ID_DEVELOPER_HEADQUARTERS = '6';
export const GROUP_ID_DEVELOPER_TEAM_LEADER = '9';
export const GROUP_ID_DEVELOPER_BRANCH_LEADER = '11';
export const GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR = '12';
export const GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = '13';
export const GROUP_ID_DEVELOPER_EXECUTIVE = '10';
export const GROUP_ID_DEVELOPER_SITEPLAN = '16';
export const GROUP_ID_DEVELOPER_AGENT_LEADER = '17';
export const GROUP_ID_DEVELOPER_AGENCY_ADMIN = '21';

export const GROUP_ID_CREDIT_CONTROL = '18';
export const GROUP_ID_CREDIT_ADMIN = '19';
export const GROUP_ID_CREDIT_CONTROL_SALES_STAFF = '31';
export const GROUP_ID_CREDIT_CONTROL_SALES_ADMIN = '32';

export const GROUP_ID_COMMISSION_TRACKER_HEADQUARTERS = '22';
export const GROUP_ID_COMMISSION_TRACKER_SUPERVISOR = '23';
export const GROUP_ID_COMMISSION_TRACKER_SALES_MANAGER = '24';
export const GROUP_ID_COMMISSION_TRACKER_SALES_ADMIN = '25';
export const GROUP_ID_COMMISSION_TRACKER_STAFF = '26';
export const GROUP_ID_COMMISSION_TRACKER_TEAM_LEADER = '27';
export const GROUP_ID_COMMISSION_TRACKER_AGENCY_ADMIN = '28';
export const GROUP_ID_COMMISSION_TRACKER_AGENT = '29';

export const GROUP_ID_FINANCE_EXECUTIVE = '20';
export const GROUP_ID_ANALYTICS = '30';

export const devGroups = [
  {
    id: GROUP_ID_DEVELOPER_HEADQUARTERS,
    code: DEVELOPER_HEADQUARTERS,
    name: 'Headquarters',
  },
  {
    id: GROUP_ID_DEVELOPER_BRANCH_LEADER,
    code: DEVELOPER_BRANCH_LEADER,
    name: 'Business Unit Leader',
  },
  {
    id: GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
    code: DEVELOPER_BRANCH_LEADER_SUPERVISOR,
    name: 'Business Unit Leader Supervisor',
  },
  {
    id: GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
    code: DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
    name: 'Business Unit Leader Supervisor II',
  },
  {
    id: GROUP_ID_DEVELOPER_EXECUTIVE,
    code: DEVELOPER_EXECUTIVE,
    name: 'Agent/Internal Staff',
  },
  {
    id: GROUP_ID_DEVELOPER_SITEPLAN,
    code: DEVELOPER_SITEPLAN,
    name: 'Basic Siteplan',
  },
  {
    id: GROUP_ID_DEVELOPER_AGENT_LEADER,
    code: DEVELOPER_AGENT_LEADER,
    name: 'Agent Leader',
  },
  {
    id: GROUP_ID_DEVELOPER_AGENCY_ADMIN,
    code: DEVELOPER_AGENCY_ADMIN,
    name: 'Agency Admin',
  },
];

export const ignoreGroupIDs = [
  GROUP_ID_CREDIT_CONTROL,
  GROUP_ID_CREDIT_ADMIN,
  GROUP_ID_CREDIT_CONTROL_SALES_STAFF,
  GROUP_ID_CREDIT_CONTROL_SALES_ADMIN,
  GROUP_ID_FINANCE_EXECUTIVE,
  GROUP_ID_COMMISSION_TRACKER_HEADQUARTERS,
  GROUP_ID_COMMISSION_TRACKER_SUPERVISOR,
  GROUP_ID_COMMISSION_TRACKER_SALES_MANAGER,
  GROUP_ID_COMMISSION_TRACKER_SALES_ADMIN,
  GROUP_ID_COMMISSION_TRACKER_STAFF,
  GROUP_ID_COMMISSION_TRACKER_TEAM_LEADER,
  GROUP_ID_COMMISSION_TRACKER_AGENCY_ADMIN,
  GROUP_ID_COMMISSION_TRACKER_AGENT,
  GROUP_ID_ANALYTICS,
];

export const creditControlGroups = [
  {
    id: GROUP_ID_CREDIT_CONTROL,
    code: CREDIT_CONTROL,
    name: 'Credit Control',
  },
  {
    id: GROUP_ID_CREDIT_ADMIN,
    code: CREDIT_ADMIN,
    name: 'Credit Admin',
  },
  {
    id: GROUP_ID_CREDIT_CONTROL_SALES_STAFF,
    code: CREDIT_CONTROL_SALES_STAFF,
    name: 'Sales Staff',
  },
  {
    id: GROUP_ID_CREDIT_CONTROL_SALES_ADMIN,
    code: CREDIT_CONTROL_SALES_ADMIN,
    name: 'Sales Admin',
  },
];

export const commissionTrackerGroups = [
  {
    id: GROUP_ID_COMMISSION_TRACKER_HEADQUARTERS,
    code: COMMISSION_TRACKER_HEADQUARTERS,
    name: 'Headquarters',
  },
  {
    id: GROUP_ID_COMMISSION_TRACKER_SUPERVISOR,
    code: COMMISSION_TRACKER_SUPERVISOR,
    name: 'Supervisor',
  },
  {
    id: GROUP_ID_COMMISSION_TRACKER_SALES_MANAGER,
    code: COMMISSION_TRACKER_SALES_MANAGER,
    name: 'Sales Manager',
  },
  {
    id: GROUP_ID_COMMISSION_TRACKER_SALES_ADMIN,
    code: COMMISSION_TRACKER_SALES_ADMIN,
    name: 'Sales Admin',
  },
  {
    id: GROUP_ID_COMMISSION_TRACKER_STAFF,
    code: COMMISSION_TRACKER_STAFF,
    name: 'Staff',
  },
  {
    id: GROUP_ID_COMMISSION_TRACKER_TEAM_LEADER,
    code: COMMISSION_TRACKER_TEAM_LEADER,
    name: 'Agency Leader',
  },
  {
    id: GROUP_ID_COMMISSION_TRACKER_AGENT,
    code: COMMISSION_TRACKER_AGENT,
    name: 'Agent',
  },
];



// WEBPACK FOOTER //
// ./src/constants/groups.js